import { venus } from '@/api/axios-api';
import { events, invitations } from '@solarApiResources';
import { invitationEntity, insightsFacebook } from '@secret-society/entities';
import mockInsightsFacebook from '@/views/tss/Event/EventViews/EventPage/InvitationPage/Tabs/Overview/insightsMock';

/**
 *
 * @param invitationId
 * @returns {Promise<{canResetSent: boolean, token: string, facebookInsights: {hasInsights: boolean, hasDayInsights: boolean, hasLifetimeInsights: boolean, periods: {day: any[] | null, lifetime: import("./typings/periods").LifetimeResult | null}, getLifetimeInsights: (name?: (LifetimeName | undefined), options?: ({keepNumber?: number | undefined} | undefined)) => (import("./typings/periods").DataLifetimeResult | import("./typings/periods").DataLifetimeResult[] | null)}, check_out_at: string, canRemind: boolean, canValidate: boolean, canDelete: boolean, guest: any, canNotify: boolean, id: string, check_in_at: string, canCancel: boolean, status: Status}>}
 */
export const fetchInvitation = async (invitationId) => {
  const { data } = await venus.request({
    ...invitations.getInvitation,
    queryParams: { id: invitationId },
    bag: {
      params: {
        include: ['view_guest', 'guest_attachments'],
      },
    },
  });

  // mock for insights facebook
  const formattedInsightsFacebook = insightsFacebook.formatInsightsFacebook(mockInsightsFacebook, {
    lifetime: {
      audienceLocale: {
        max: 3,
      },
      audienceCity: {
        max: 3,
      },
    },

  });

  return { ...invitationEntity.formatFromApi(data), facebookInsights: formattedInsightsFacebook };
};

/**
 *
 * @param idEvent
 * @param options
 * @returns {Promise<{data, paging}>}
 */
export const fetchInvitations = async (idEvent, options = {}) => {
  const { data, paging } = await venus.request({
    ...events.getInvitationsOfEvent,
    queryParams: { id: idEvent },
    bag: {
      page: options?.page,
      size: options?.size,
      sort: options?.sort,
      params: {
        include: ['view_guest', 'guest_attachments'],
      },
      filters: { status: 'confirmed' },
    },
  });

  return {
    data: data.map(invitationEntity.formatFromApi),
    paging,
  };
};
